module.exports = __webpack_public_path__ + "static/media/calendar_social.f4d9019c.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/products/artist/assets/calendar_social.png
// module id = 248
// module chunks = 0